import { HttpContext } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { LANG_TOKEN, type RequestOptions } from "@3volutionsag/ngx-rooms-lib";

import { SERVICEUSER_TOKEN } from "../authentication/auth.interceptor";
import { ConfigurationState } from "../configuration/state/configuration.state";

export enum RequestAuthMode {
	User = "user",
	ServiceUser = "serviceUser",
}

export interface ApiWithRequestAuth {
	onExecuteFn?: (reqOptions?: RequestOptions) => void;
}

@Injectable({
	providedIn: "root",
})
export class HttpRequestHelperService {
	private store = inject(Store);

	/**
	 * Prepares the next API call with an explicit authentication mode.
	 * The rooms-lib API services consume onExecuteFn once and then clear it.
	 */
	public prepareApiRequest(api: ApiWithRequestAuth, mode: RequestAuthMode): void {
		api.onExecuteFn = (reqOptions?: RequestOptions) => this.prepareRequest(mode, reqOptions);
	}

	/**
	 * Prepares request options for API calls, configuring the HTTP context
	 * with appropriate language and authentication settings.
	 *
	 * @param mode Which token should authorize the request
	 * @param reqOptions Request options to be modified
	 * @param ctx Optional HTTP context
	 */
	public prepareRequest(
		mode: RequestAuthMode,
		reqOptions?: RequestOptions,
		ctx?: HttpContext,
	): void {
		if (!reqOptions) {
			return;
		}

		let context = ctx || new HttpContext();
		if (mode === RequestAuthMode.User) {
			reqOptions.context = context.set(SERVICEUSER_TOKEN, false);
			return;
		}

		const dsConfig = this.store.selectSnapshot(ConfigurationState.dsConfiguration);

		// The data returned from rooms must be in the language of the resource and not of the service user.
		context = context.set(LANG_TOKEN, dsConfig?.locale).set(SERVICEUSER_TOKEN, true);
		reqOptions.context = context;
	}
}
